import classnames from 'classnames';
import { forwardRef } from 'react';
import type { ResizeHandle } from 'react-resizable';

interface ResizeHandlerProps {
  handleAxis?: ResizeHandle;
}

export const ResizeHandler = forwardRef<HTMLDivElement, ResizeHandlerProps>(
  ({ handleAxis, ...props }, ref) => {
    return (
      <div
        {...props}
        ref={ref}
        className={classnames(
          `handle-${handleAxis}`,
          'absolute top-0 -right-3 w-3 cursor-col-resize h-full bg-transparent z-10'
        )}
      />
    );
  }
);

ResizeHandler.displayName = 'Resizable';
